module.exports = __webpack_public_path__ + "img/SET_COMO_29_31.dd2707a1.jpg";